import { Injectable, inject } from '@angular/core';
import { withClassicBasketEntry } from '../../classic-basket-entry';
import { NavigationTarget } from '../../navigation-target';
import { PortalRegion } from '../../portal-region';
import { LegacyRoutes } from '../../portal-routes';
import { PortalUrls } from '../../portal-urls.service';
import { LandingContext, LandingRule } from '../landing-rule';

/** Exception for China: buyers work in the Legacy basket instead of Order Pro. */
@Injectable({ providedIn: 'root' })
export class ChinaBuyerBasketLandingRule implements LandingRule {
  private readonly urls = inject(PortalUrls);

  resolve({ region }: LandingContext): NavigationTarget | null {
    return region === PortalRegion.China
      ? NavigationTarget.external(withClassicBasketEntry(this.urls.legacyPortal(LegacyRoutes.basket)))
      : null;
  }
}
